/**
 * Shared payment method options used across the application.
 * Matches PaymentsScreen filter and edit modal options.
 */

export const PAYMENT_METHOD_OPTIONS = [
  { value: 'Cash', label: 'Cash' },
  { value: 'Transfer', label: 'Transfer' },
  { value: 'Online', label: 'Online Payment' },
  { value: 'Cheque', label: 'Cheque' },
  { value: 'Paymob', label: 'Paymob' },
  { value: 'Thawani', label: 'Thawani' },
];

export const PAYMENT_METHOD_OPTIONS_WITH_ALL = [
  { value: '', label: 'All Methods' },
  ...PAYMENT_METHOD_OPTIONS,
];

export const PAYMENT_METHODS = {
  Cash: 'Cash',
  Transfer: 'Transfer',
  Online: 'Online Payment',
  Cheque: 'Cheque',
  Paymob: 'Paymob',
  Thawani: 'Thawani',
};

export function getPaymentMethodLabel(value) {
  if (!value) return '—';
  const opt = PAYMENT_METHOD_OPTIONS.find((o) => o.value === value);
  return opt ? opt.label : value;
}

/** True when amount parses to a finite number strictly greater than zero. */
export function isPositivePaymentAmount(amount) {
  const n = parseFloat(amount);
  return Number.isFinite(n) && n > 0;
}
